import styled from "styled-components";

export const Container = styled.div<{ isGraphic: boolean }>`
    width: 97%;
    height: auto;
    max-height: calc(100vh - 90px);
    overflow: visible;
    
    position: absolute;
    top: 85px;
    z-index: 10;
    background-color: #fff;
    margin-left: 27px;
    border-radius: 8px;
    padding: ${(props) => !props.isGraphic ? "24px" : "24px 24px 0 24px"};

    display: flex;
    flex-direction: column;
    min-height: 0;

    .ant-form-item {
        display: flex;
        flex-direction: column;
        

        .ant-form-item-label {
            text-align: left;
        }
    }

`;